export default __webpack_public_path__ + "static/media/coinbase_icon.cff64e5f.png";